module.exports = __webpack_public_path__ + "static/6-2b1d6d11fb3902105e59bf976d29e9ac.jpeg";